// import React, { useState } from 'react';
// import { Helmet } from 'react-helmet';

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     subject: '',
//     message: '',
//   });

//   const [submitted, setSubmitted] = useState(false);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log('Form submitted:', formData);
//     setSubmitted(true);
//     setTimeout(() => {
//       setSubmitted(false);
//       setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
//     }, 3000);
//   };

//   const contactInfo = [
//     {
//       icon: (
//         <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//         </svg>
//       ),
//       label: "Email",
//       value: "info@citypulsellc.com",
//       accent: "from-teal-400 to-cyan-300",
//     },
//     {
//       icon: (
//         <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h2.28a2 2 0 011.9 1.37l1.2 3.6a2 2 0 01-.45 2.11l-1.27 1.27a16 16 0 006.36 6.36l1.27-1.27a2 2 0 012.11-.45l3.6 1.2A2 2 0 0121 16.72V19a2 2 0 01-2 2h-1C8.16 21 3 15.84 3 9V5z" />
//         </svg>
//       ),
//       label: "Phone",
//       value: "+19162932536",
//       accent: "from-blue-400 to-indigo-300",
//     },
//     {
//       icon: (
//         <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z" />
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
//         </svg>
//       ),
//       label: "Address",
//       value: "4654 Scenic Vista Dr, Folsom, 95630, USA",
//       accent: "from-emerald-400 to-teal-300",
//     },
//   ];

//   const inputClass = "w-full px-4 py-3 border border-slate-200 rounded-xl bg-stone-50 text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-300 focus:border-transparent transition-all";
//   const labelClass = "block text-sm font-semibold text-slate-600 mb-2";

//   return (
//     <div className="bg-stone-50 text-gray-800" style={{ fontFamily: "'Georgia', 'Times New Roman', serif" }}>
//       <Helmet>
//         <meta charSet="utf-8" />
//         <title>CityPulse LLC | Contact Us</title>
//         <link rel="canonical" href="https://citypulsellc.com/contact" />
//       </Helmet>

//       {/* Header */}
//       <section className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-teal-50 to-cyan-100 py-32 border-b border-teal-100">
//         <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-teal-200 opacity-20" />
//         <div className="absolute bottom-0 left-1/3 w-64 h-64 rounded-full bg-cyan-200 opacity-20" />
//         <div className="absolute top-16 left-8 w-32 h-32 rounded-full bg-blue-200 opacity-20" />

//         <div className="relative max-w-7xl mx-auto px-6">
//           <div className="inline-flex items-center gap-2 bg-white border border-teal-200 rounded-full px-4 py-1.5 mb-8 shadow-sm">
//             <span className="w-2 h-2 rounded-full bg-teal-500 inline-block" />
//             <span className="text-xs font-medium tracking-widest uppercase text-teal-700" style={{ fontFamily: 'system-ui, sans-serif' }}>
//               Reach Out
//             </span>
//           </div>

//           <h1 className="text-6xl md:text-7xl font-bold mb-6 tracking-tight text-slate-900 leading-none">
//             Contact{" "}
//             <span className="relative inline-block">
//               <span className="relative z-10 text-teal-600">Us</span>
//               <span className="absolute bottom-1 left-0 w-full h-3 bg-teal-200 opacity-50 rounded" />
//             </span>
//           </h1>

//           <p className="text-xl text-slate-500 max-w-2xl leading-relaxed" style={{ fontFamily: 'system-ui, sans-serif', fontWeight: 400 }}>
//             Get in touch with City Pulse. We're here to answer your questions and discuss how we can support your mortgage processing needs.
//           </p>
//         </div>
//       </section>

//       {/* Contact Section */}
//       <section className="py-28">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">

//             {/* Contact Form */}
//             <div className="bg-gradient-to-br from-teal-400 to-cyan-300 p-0.5 rounded-3xl shadow-xl shadow-teal-100">
//               <div className="bg-white rounded-3xl p-10">
//                 <h2 className="text-4xl font-bold text-slate-900 mb-8">
//                   Send Us a Message
//                 </h2>

//                 {submitted && (
//                   <div className="bg-teal-50 border border-teal-200 rounded-2xl p-5 mb-8 flex items-center gap-3">
//                     <span className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-br from-teal-400 to-cyan-300 flex items-center justify-center">
//                       <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
//                         <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
//                       </svg>
//                     </span>
//                     <p className="text-teal-800 font-semibold" style={{ fontFamily: 'system-ui, sans-serif' }}>
//                       Thank you! Your message has been sent successfully.
//                     </p>
//                   </div>
//                 )}

//                 <form onSubmit={handleSubmit} className="space-y-6" style={{ fontFamily: 'system-ui, sans-serif' }}>
//                   <div>
//                     <label htmlFor="name" className={labelClass}>Full Name *</label>
//                     <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className={inputClass} placeholder="John Doe" />
//                   </div>

//                   <div>
//                     <label htmlFor="email" className={labelClass}>Email Address *</label>
//                     <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className={inputClass} placeholder="john.doe@example.com" />
//                   </div>

//                   <div>
//                     <label htmlFor="phone" className={labelClass}>Phone Number</label>
//                     <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className={inputClass} placeholder="(555) 123-4567" />
//                   </div>

//                   <div>
//                     <label htmlFor="subject" className={labelClass}>Subject *</label>
//                     <select id="subject" name="subject" required value={formData.subject} onChange={handleChange} className={inputClass}>
//                       <option value="">Select a subject</option>
//                       <option value="services">Services Inquiry</option>
//                       <option value="careers">Career Opportunity</option>
//                       <option value="general">General Inquiry</option>
//                       <option value="support">Support Request</option>
//                     </select>
//                   </div>

//                   <div>
//                     <label htmlFor="message" className={labelClass}>Message *</label>
//                     <textarea id="message" name="message" required rows="5" value={formData.message} onChange={handleChange} className={`${inputClass} resize-none`} placeholder="Tell us how we can help you..." />
//                   </div>

//                   <button
//                     type="submit"
//                     className="w-full inline-flex items-center justify-center gap-2 bg-gradient-to-r from-teal-500 to-cyan-400 hover:from-teal-600 hover:to-cyan-500 text-white font-semibold py-4 px-8 rounded-full transition-all shadow-lg shadow-teal-200 hover:scale-105"
//                   >
//                     Send Message
//                     <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//                       <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
//                     </svg>
//                   </button>
//                 </form>
//               </div>
//             </div>

//             {/* Contact Information */}
//             <div className="flex flex-col gap-8">
//               {/* Intro card */}
//               <div className="bg-gradient-to-br from-blue-400 to-indigo-300 p-0.5 rounded-3xl shadow-xl shadow-blue-100">
//                 <div className="bg-white rounded-3xl p-10">
//                   {/* Decorative dot grid */}
//                   <div className="grid grid-cols-6 gap-2 mb-8 opacity-20">
//                     {Array.from({ length: 12 }).map((_, i) => (
//                       <span key={i} className="w-1.5 h-1.5 rounded-full bg-slate-400 block" />
//                     ))}
//                   </div>
//                   <h2 className="text-4xl font-bold text-slate-900 mb-4">
//                     Get in Touch
//                   </h2>
//                   <p className="text-slate-500 leading-relaxed" style={{ fontFamily: 'system-ui, sans-serif', fontWeight: 400 }}>
//                     We're here to help. Reach out to us through any of the following channels, and we'll get back to you as soon as possible.
//                   </p>
//                 </div>
//               </div>

//               {/* Contact info cards */}
//               <div className="space-y-4">
//                 {contactInfo.map((info, index) => (
//                   <div key={index} className="bg-white border border-slate-100 rounded-2xl p-6 flex items-start gap-5 shadow-sm hover:shadow-md transition-all relative overflow-hidden">
//                     <div className={`absolute top-0 left-0 bottom-0 w-1 bg-gradient-to-b ${info.accent} rounded-l-2xl`} />
//                     <div className={`flex-shrink-0 w-11 h-11 rounded-2xl bg-gradient-to-br ${info.accent} flex items-center justify-center shadow-sm`}>
//                       {info.icon}
//                     </div>
//                     <div style={{ fontFamily: 'system-ui, sans-serif' }}>
//                       <h3 className="text-sm font-semibold tracking-widest uppercase text-slate-400 mb-1">{info.label}</h3>
//                       <p className="text-slate-700 font-medium">{info.value}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Contact;




import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

const Contact = () => {

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;
    const data = new FormData(form);
    const phpResponse = await fetch(
      // 'http://localhost/CityPulse/api/contact.php',
      'https://citypulsellc.com/api/contact.php',
      {
        method: 'POST',
        body: data,
      });
    const phpResult = await phpResponse.json();

    if (phpResult.status !== "success") {
      alert("Upload failed");
      return;
    }

    alert("Application submitted successfully!");
    form.reset();
    setLoading(false);
  };

  return (
    <div className="bg-white">
      <Helmet>
        <meta charSet="utf-8" />
        <title>CityPulse LLC | Contact Us</title>
        <link rel="canonical" href="https://citypulsellc.com/contact" />
      </Helmet>
      {/* Header */}
      {/* <section className="relative bg-gradient-to-r from-primary to-primary-dark text-white py-20 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')`
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary/95 to-primary-dark/95"></div>
        <div className="absolute inset-0 bg-grid"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="glass-card rounded-2xl p-8 md:p-12 inline-block">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 text-primary">Contact Us</h1>
            <p className="text-xl text-gray-700 max-w-3xl font-semibold">
              Get in touch with City Pulse. We're here to answer your questions
              and discuss how we can support your mortgage processing needs.
            </p>
          </div>
        </div>
      </section> */}

      <section className="relative min-h-[60vh] flex flex-col justify-center overflow-hidden bg-gray-950">

        {/* Background photo */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')`
          }}
        />
        {/* Layered overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-gray-950/95 via-gray-900/80 to-blue-900/50" />

        {/* Decorative blobs + dot grid */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-blue-500/20 blur-3xl" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-indigo-500/10 blur-3xl" />
          <div
            className="absolute inset-0 opacity-10"
            style={{
              backgroundImage: `radial-gradient(circle, #fff 1px, transparent 1px)`,
              backgroundSize: `32px 32px`,
            }}
          />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">

          {/* Eyebrow badge */}
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-blue-300">
              <span className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
              Get In Touch
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white leading-none mb-6 max-w-3xl">
            Contact
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-300 mt-1">
              Us
            </span>
          </h1>

          {/* Accent divider */}
          <div className="flex items-center gap-4 mb-6">
            <div className="h-px w-16 bg-gradient-to-r from-blue-400 to-transparent" />
            <div className="w-2 h-2 rounded-full bg-blue-400" />
          </div>

          {/* Description */}
          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl leading-relaxed mb-10">
            Get in touch with City Pulse. We're here to answer your questions
            and discuss how we can support your mortgage processing needs.
          </p>

          {/* Quick contact pills */}
          <div className="flex flex-wrap gap-3">
            <a
              href="mailto:info@citypulsellc.com"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/15 border border-white/20 backdrop-blur-sm rounded-full px-4 py-2 text-sm text-gray-300 hover:text-white transition-all duration-200"
            >
              <svg className="w-4 h-4 text-blue-400" viewBox="0 0 16 16" fill="none">
                <path d="M2 4h12v9H2V4z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
                <path d="M2 4l6 5 6-5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
              </svg>
              info@citypulsellc.com
            </a>
            <a
              href="tel:+1234567890"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/15 border border-white/20 backdrop-blur-sm rounded-full px-4 py-2 text-sm text-gray-300 hover:text-white transition-all duration-200"
            >
              <svg className="w-4 h-4 text-blue-400" viewBox="0 0 16 16" fill="none">
                <path d="M3 2h3l1.5 3.5-1.5 1a8 8 0 004 4l1-1.5L14.5 10v3A1.5 1.5 0 0113 14.5C6.6 14.5 1.5 9.4 1.5 3A1.5 1.5 0 013 1.5V2z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
              </svg>
              Call Us Today
            </a>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="relative py-20 bg-gray-50 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-fixed opacity-15"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')`
          }}
        ></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div className="glass-card rounded-2xl p-8">
              <h2 className="text-3xl font-bold text-primary mb-6">
                Send Us a Message
              </h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-sm font-semibold text-gray-700 mb-2"
                  >
                    Full Name  <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                    placeholder="Enter your name"
                  />
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-semibold text-gray-700 mb-2"
                  >
                    Email Address  <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                    placeholder="Enter your email"
                  />
                </div>

                <div>
                  <label
                    htmlFor="phone"
                    className="block text-sm font-semibold text-gray-700 mb-2"
                  >
                    Phone Number  <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                    placeholder="Enter your phone number"
                  />
                </div>

                <div>
                  <label
                    htmlFor="city"
                    className="block text-sm font-semibold text-gray-700 mb-2"
                  >
                    City  <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                    placeholder="Enter your city"
                  />
                </div>

                <div>
                  <label
                    htmlFor="message"
                    className="block text-sm font-semibold text-gray-700 mb-2"
                  >
                    Message  <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows="6"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all resize-none"
                    placeholder="Tell us how we can help you..."
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-primary hover:bg-primary-dark text-white font-semibold py-3 px-8 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg"
                >
                  {loading ? 'Loading...' : 'Send Message'}
                </button>
              </form>
            </div>

            {/* Contact Information */}
            <div className="glass-card rounded-2xl p-8">
              <h2 className="text-3xl font-bold text-primary mb-6">
                Get in Touch
              </h2>
              <p className="text-gray-700 mb-8">
                We're here to help. Reach out to us through any of the following
                channels, and we'll get back to you as soon as possible.
              </p>

              <div className="space-y-6 mb-8">
                <div className="flex items-start">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
                    <svg
                      className="w-6 h-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-primary mb-1">
                      Email
                    </h3>
                    <p className="text-gray-700">info@citypulsellc.com</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
                    <svg
                      className="w-6 h-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 5a2 2 0 012-2h2.28a2 2 0 011.9 1.37l1.2 3.6a2 2 0 01-.45 2.11l-1.27 1.27a16 16 0 006.36 6.36l1.27-1.27a2 2 0 012.11-.45l3.6 1.2A2 2 0 0121 16.72V19a2 2 0 01-2 2h-1C8.16 21 3 15.84 3 9V5z"
                      />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-primary mb-1">
                      Phone
                    </h3>
                    <p className="text-gray-700">+19162932536</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
                    <svg
                      className="w-6 h-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-primary mb-1">
                      Address
                    </h3>
                    <p className="text-gray-700">
                      4654 Scenic Vista Dr<br />
                      Folsom, 95630<br />
                      USA
                    </p>
                  </div>
                </div>




              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;

